
const data = {
    "interview":[
        {
            "title":"”Google Cloud Challenge 2022”の優勝チームにインタビューしてみた",
            "date":"2023/3",
            "link":"https://www.topgate.co.jp/blog/tg-culture/29121"
        },
        {
            "title":"未来のエンジニアを育てる「技育展」にスポンサーとして初参加しました！",
            "date":"2022/12",
            "link":"https://blog.brainpad.co.jp/entry/2022/12/08/150021"
        },
        {
            "title":"快適なオンライン飲み会体験を提供する「のみぱら」がＪストリーム賞を受賞 ー JPHACKS2022",
            "date":"2022/11",
            "link":"https://voice.stream.co.jp/event/20221129/"
        },
    ]
}

export default data;
